import { MeetHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const GetOrgUnitAthleteEntryAggregateRelayAthleteData = (omeMeetOrgUnitEntryId, meetEventId, state, setState) => {
  if (state.isObjLoading !== true) {
    const newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const omeMeetOrgUnitEntryIdForUrl = omeMeetOrgUnitEntryId ? encodeURIComponent(omeMeetOrgUnitEntryId) : 'NaN';
    const meetEventIdForUrl = meetEventId ? encodeURIComponent(meetEventId) : 'NaN';
    const url = `/OrgUnitAthleteEntry/omeMeetOrgUnitEntry/${omeMeetOrgUnitEntryIdForUrl}/aggregateRelayAthlete/meetEvent/${meetEventIdForUrl}`;
    MeetHttpHelper(url, 'GET')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          message: message
        });
      });
  }
};

export default GetOrgUnitAthleteEntryAggregateRelayAthleteData;